import { BaseFetch } from "../main-model"
export default class RoomModel extends BaseFetch {
  getRoomBy = (data) =>
    this.authFetch({
      url: "room/getRoomBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getRoomById = (data) =>
    this.authFetch({
      url: "room/getRoomById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateRoomById = (data) =>
    this.authFetch({
      url: "room/updateRoomById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertRoom = (data) =>
    this.authFetch({
      url: "room/insertRoom",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteRoomById = (data) =>
    this.authFetch({
      url: "room/deleteRoomById",
      method: "POST",
      body: JSON.stringify(data),
    })
    checkRoom = (data) =>
    this.authFetch({
      url: "room/checkRoom",
      method: "POST",
      body: JSON.stringify(data),
    })
    getRoomByBuilding = (data) =>
      this.authFetch({
        url: "room/getRoomByBuilding",
        method: "POST",
        body: JSON.stringify(data),
      })
}
